<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span @click="GoreportOutside">武装自己></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>【纪检监察群英谱】郝兴锐：把“冷板凳”坐热</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>寒来暑往、挑灯夜战，他与公文结缘、与写作相“恋”。</h3>
        <h3>　在公文写作岗位奋战17年，由他采编的信息多次获中央办公厅、中央纪委信息采用。</h3>
        <h3>　他，就是南漳县反腐倡廉教育站站长郝兴锐。</h3>
        <h3>　挥洒汗水、倾注心血、奉献青春，郝兴锐无怨无悔，始终用文风历练作风、用笔杆创造价值、用自律坚守本分。</h3>
        <h3>长期以来，郝兴锐始终保持着这样的习惯：凡是经他撰写的公文材料，每篇成稿在交付前，至少通读、修改、校对10遍。</h3>
        <h3>他坚持自我加压，广集博览，及时了解委局工作重点，及时了解上级领导关注的热点，及时了解外地工作亮点，做到开阔视野，与时俱进。</h3>
        <h3>　纪检监察工作离不开“案子”和“稿子”，郝兴锐充分发挥“稿子”作用，及时总结宣传，扩大南漳县纪检监察工作对上对外影响力，挖掘典型案例，扩大警示教育震慑力。</h3>        
        <div class="PIC-BOX">
          <img :src="PicBannertest2" alt />
        </div>
        <h3>据了解，五年来，他先后撰写公文材料、理论调研、新闻信息、案例剖析等稿件500余篇次，被中央、省、市媒体采用210篇次，在国家级媒体刊发19篇次，在市级以上会议发言、交流及领导批示50多篇。</h3>
        <h3>　从事材料写作，凭的是坐功，需要坐“冷板凳”。但郝兴锐始终怀着一颗平常心，兢兢业业干好本职工作，用行动诠释着不忘初心、牢记使命的责任担当。</h3>
        <h3>由于长期伏案工作，郝兴锐患上颈椎病、腰椎病、肩周炎、胃炎等职业病。遇到紧急任务，他加班加点，有时通宵达旦。但他始终坚持，满怀热诚。</h3>
        <h3>　近年来，郝兴锐先后荣获省纪委表彰4次，市、县表彰11次。</h3>
        <h3>　面对荣誉，郝兴锐依旧谦虚：“我都是我应该做的。我只是这个优秀群体的一员。”</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/wzzj1-1.jpg"),
      PicBannertest2: require("../../../../assets/image/wzzj2-1.jpg"),
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    },
    GoreportOutside(){
      this.$router.push({ name: "forumOutside" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
   padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img {
  margin: 20px 0;
}
.mg-16{
  margin: 0px 16px;
}
</style>